export default __webpack_public_path__ + "static/media/str_espresso.9d000652.jpg";